import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { AuthProvider } from '@/auth/AuthProvider'
import { FiscalYearProvider } from '@/lib/fiscalYear'
import { queryClient } from '@/lib/queryClient'
import { registerServiceWorker } from '@/lib/serviceWorker'
import { router } from '@/routes'
import './index.css'

const container = document.getElementById('root')
if (container === null) throw new Error('Missing #root element')

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <FiscalYearProvider>
          <RouterProvider router={router} />
        </FiscalYearProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)

// After render: the app must be usable whether or not this succeeds.
registerServiceWorker()
